import { PropsWithChildren, createContext, useContext, useMemo } from 'react'

import {
  useFixTradingWebSocket,
  type UseFixTradingWebSocketOptions,
  type UseFixTradingWebSocketResult,
} from '../hooks/useFixTradingWebSocket'

const FixTradingWebSocketContext = createContext<UseFixTradingWebSocketResult | undefined>(
  undefined
)

export type FixTradingWebSocketProviderProps = PropsWithChildren<UseFixTradingWebSocketOptions>

export const FixTradingWebSocketProvider = ({
  children,
  ...options
}: FixTradingWebSocketProviderProps) => {
  const result = useFixTradingWebSocket(options)

  const value = useMemo(
    () => ({
      readyState: result.readyState,
      cancelOrder: result.cancelOrder,
      newOrder: result.newOrder,
      newOrderList: result.newOrderList,
      changePendingOrderSlTp: result.changePendingOrderSlTp,
      replaceOrder: result.replaceOrder,
      closePosition: result.closePosition,
      closeAllPositions: result.closeAllPositions,
    }),
    [
      result.readyState,
      result.cancelOrder,
      result.newOrder,
      result.newOrderList,
      result.changePendingOrderSlTp,
      result.replaceOrder,
      result.closePosition,
      result.closeAllPositions,
    ]
  )

  return (
    <FixTradingWebSocketContext.Provider value={value}>
      {children}
    </FixTradingWebSocketContext.Provider>
  )
}

export const useFixTradingWebSocketContext = (): UseFixTradingWebSocketResult => {
  const context = useContext(FixTradingWebSocketContext)
  if (!context) {
    throw new Error('useFixTradingWebSocketContext must be used within FixTradingWebSocketProvider')
  }
  return context
}
